import { Link } from 'gatsby';
import { PropTypes } from 'prop-types';
import React, { useEffect, useState } from 'react';

import FacebookIcon from '../../../assets/svg/facebook.svg';
import LinkedInIcon from '../../../assets/svg/linkedin.svg';
import TwitterIcon from '../../../assets/svg/twitter.svg';

const ArticleEnd = ({ credits, pageLocation, tags }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  const renderTags = (tag) => {
    return (
      <Link
        className="article__end--tag"
        data-component-id="article_end_tag_link"
        to={`/${tag.type}/${tag.slug}/`}
      >
        {tag.name}
      </Link>
    );
  };

  const creditPhotographers = (credit) => {
    return (
      <div className="photographer">
        {`Photography by `}
        <span>{credit.name}</span>
      </div>
    );
  };

  const creditIllustrators = (credit) => {
    return (
      <div className="illustrator">
        {`Illustration by `}
        <span>{credit.name}</span>
      </div>
    );
  };

  const creditAuthors = (credit) => {
    return (
      <div className="author">
        {`Written by `}
        <span>{credit.name}</span>
      </div>
    );
  };

  return (
    <div className="article__end">
      <div className="article__end--social_tag">
        <div
          className="article__end--social-icons"
          data-component-id="article_end_social_link"
        >
          <a
            aria-label="Share on Facebook"
            data-tracking-event="share"
            data-tracking-method="Facebook"
            href={`https://www.facebook.com/sharer/sharer.php?u=${pageLocation.href}`}
            rel="noreferrer"
            target="_blank"
          >
            <FacebookIcon />
          </a>
          <a
            aria-label="Share on Twitter"
            data-tracking-event="share"
            data-tracking-method="Twitter"
            href={`http://twitter.com/share?url=${pageLocation.href}`}
            rel="noreferrer"
            target="_blank"
          >
            <TwitterIcon />
          </a>
          <a
            aria-label="Share on LinkedIn"
            data-tracking-event="share"
            data-tracking-method="LinkedIn"
            href={`https://www.linkedin.com/shareArticle?mini=true&url=${pageLocation.href}`}
            rel="noreferrer"
            target="_blank"
          >
            <LinkedInIcon />
          </a>
        </div>
        {tags && (
          <div className="article__end--tags">
            {tags.map((tag) => renderTags(tag))}
          </div>
        )}
      </div>
      {credits && (
        <div className="article__end--credits">
          {credits
            .filter((credit) => credit.type === 'photographer')
            .map((credit) => creditPhotographers(credit))}
          {credits
            .filter((credit) => credit.type === 'illustrator')
            .map((credit) => creditIllustrators(credit))}
          {credits
            .filter((credit) => credit.type === 'author')
            .map((credit) => creditAuthors(credit))}
        </div>
      )}
    </div>
  );
};

ArticleEnd.propTypes = {
  credits: PropTypes.string,
  pageLocation: PropTypes.object,
  tags: PropTypes.string,
};

export default ArticleEnd;
